import { render } from "./DocsAccountsPage.vue?vue&type=template&id=d7bde466&scoped=true"
import script from "./DocsAccountsPage.vue?vue&type=script&lang=js"
export * from "./DocsAccountsPage.vue?vue&type=script&lang=js"

import "./DocsAccountsPage.vue?vue&type=style&index=0&id=d7bde466&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7bde466"]])

export default __exports__